import { StringKey } from '../../../lang/index';
import { StakeholderSortBy } from '../../../types/stakeholder.types';

export enum Column {
  ACTION = 'action',
  CHECK_BOX = 'check-box',
  DOCUMENTS = 'documents',
  EMAIL = 'email',
  FULL_NAME = 'full-name',
  LAST_ACTIVE = 'last-active',
  STATUS = 'status',
  TYPE = 'type',
  VOTING_RIGHTS = 'voting-rights',
}

export const columnTranslationKey: Record<Column, StringKey> = {
  [Column.CHECK_BOX]: 'EMPTY',
  [Column.FULL_NAME]: 'NAME',
  [Column.TYPE]: 'TYPE',
  [Column.EMAIL]: 'EMAIL',
  [Column.LAST_ACTIVE]: 'LAST_ACTIVE',
  [Column.VOTING_RIGHTS]: 'VOTING_RIGHTS',
  [Column.DOCUMENTS]: 'DOCUMENTS',
  [Column.STATUS]: 'STATUS',
  [Column.ACTION]: 'EMPTY',
};

export const columnToStakeholderSortColumnMap: PartialRecord<Column, StakeholderSortBy> = {
  [Column.FULL_NAME]: StakeholderSortBy.FULL_NAME,
  [Column.TYPE]: StakeholderSortBy.TYPE,
  [Column.VOTING_RIGHTS]: StakeholderSortBy.VOTING_RIGHTS,
  [Column.LAST_ACTIVE]: StakeholderSortBy.LAST_ACTIVE,
};

export const columnOrderMap = Object.keys(columnTranslationKey);
